/** The fixed six-colour palette from FR-4. No free colour picker, no custom hex. */
export const MODIFIER_STYLE_COLOURS = [
  { name: 'Burnt orange', color: '#B15000' },
  { name: 'Blue', color: '#114DD0' },
  { name: 'Purple', color: '#7B25CB' },
  { name: 'Magenta', color: '#B30059' },
  { name: 'Teal', color: '#007067' },
  { name: 'Charcoal', color: '#282828' },
] as const;

/** Union of the six valid modifier-style hex values. */
export type ModifierStyleColor =
  (typeof MODIFIER_STYLE_COLOURS)[number]['color'];
